var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.dispatchRequest ? _c('div', [_c('h3', [_vm._v("Print pakbon")]), _vm.hasPermission('orders.dispatchrequests.downloadpackingslip') ? _c('p', [_vm._v(" Klik hier om te downloaden: "), _c('download-packing-slip-button', {
    staticClass: "p-2",
    attrs: {
      "dispatch-request": _vm.dispatchRequest,
      "always-show": true,
      "variant": "secondary"
    }
  }, [_vm._v(" Download pakbon (en label) ")]), _c('print-labels-button', {
    staticClass: "ml-2",
    attrs: {
      "dispatch-request": _vm.dispatchRequest
    }
  })], 1) : _vm._e(), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('success', {});
      }
    }
  }, [_vm._v("Ga verder")])], 1) : _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" Pakbon niet beschikbaar ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }